import { TOOlTIP_FIELDS } from 'static/tooltipFields';

export const HEADER_FIELDS = [
  'qaSpecification.type',
  'qaSpecification.retailBanner',
  'qaSpecification.status',
  'qaSpecification.competitiveProduct',
  'qaSpecification.competitiveProductUpc',
  'qaSpecification.competitiveBrandEquivalencyType',
  'qaSpecification.differencesAccepted',
  'qaSpecification.competitiveProductBrandRetailPricingTarget',
  'qaSpecification.testingTier',
  'qaSpecification.skuType',
  'qaSpecification.smartLabelTemplate',
  'qaSpecification.supplierLocation',
  'qaSpecification.cat1Name',
  'qaSpecification.cat2Name',
  'qaSpecification.cat3Name',
  'qaSpecification.cat4Name',
];

export const HIDDEN_TOOLTIP_FIELDS = [
  'qaSpecification.status',
  'qaSpecification.allergens.allergenRelatedInformation.allergen.regional',
  'qaSpecification.allergens.allergenRelatedInformation.allergen.isPublish',
  'qaSpecification.factPanels.nutritionalInformation.numberOfServingsPerPackage',
  'qaSpecification.productSpecification.pfasTested',
];

export const CUSTOM_MISSING_TOOLTIP_FIELDS = {
  'qaSpecification.productSpecification': {
    childFields: [
      {
        fieldName:
          TOOlTIP_FIELDS.productSpecificationCertificateBadge.fieldPath,
        displayName: 'Certificate Badge or Other Certifications',
        childFields: null,
      },
      {
        fieldName:
          TOOlTIP_FIELDS.productSpecificationSupportingDocument.fieldPath,
        displayName: 'Supporting Documentation',
        childFields: null,
      },
    ],
  },
  'qaSpecification.certificate': {
    childFields: [
      {
        fieldName: TOOlTIP_FIELDS.documentName.fieldPath,
        displayName: 'Document Name',
        childFields: null,
      },
      {
        fieldName: TOOlTIP_FIELDS.characteristicType.fieldPath,
        displayName: 'Characteristic Type',
        childFields: null,
      },
      {
        fieldName: TOOlTIP_FIELDS.certificateStatus.fieldPath,
        displayName: 'Status',
        childFields: null,
      },
      {
        fieldName: TOOlTIP_FIELDS.finalArtJobId.fieldPath,
        displayName: 'Final Art Job Id',
        childFields: null,
      },
      {
        fieldName: TOOlTIP_FIELDS.finalArtDocumentName.fieldPath,
        displayName: 'Final Art Document Name',
        childFields: null,
      },
      {
        fieldName: TOOlTIP_FIELDS.finalArtUploadDate.fieldPath,
        displayName: 'Final Art Upload Date',
        childFields: null,
      },
    ],
  },

  'qaSpecification.allergens': {
    'qaSpecification.allergens.allergenRelatedInformation': {
      'qaSpecification.allergens.allergenRelatedInformation.allergen': {
        childFields: [
          {
            fieldName: TOOlTIP_FIELDS.allergenIsPresent.fieldPath,
            displayName: 'Is Present',
            childFields: null,
          },
        ],
      },
    },
  },

  'qaSpecification.factPanels': {
    'qaSpecification.factPanels.nutritionalInformation': {
      childFields: [
        {
          fieldName: TOOlTIP_FIELDS.servingsPerContainer.fieldPath,
          displayName: 'Servings Per Container',
          childFields: null,
        },
        {
          fieldName: TOOlTIP_FIELDS.labelType.fieldPath,
          displayName: 'Label Type',
          childFields: null,
        },
        {
          fieldName: TOOlTIP_FIELDS.ingredientNotice.fieldPath,
          displayName: 'Ingredient Notice',
          childFields: null,
        },
        {
          fieldName: TOOlTIP_FIELDS.nutritionFdaLabelFootNote.fieldPath,
          displayName: 'Footer Note',
          childFields: null,
        },
        {
          fieldName: TOOlTIP_FIELDS.factPanelsLanguageCode.fieldPath,
          displayName: 'Language Code',
          childFields: null,
        },
      ],
    },
    'qaSpecification.factPanels.supplementInformation': {
      childFields: [
        {
          fieldName: TOOlTIP_FIELDS.supplementTypeCode.fieldPath,
          displayName: 'Label Type',
          childFields: null,
        },
        {
          fieldName: TOOlTIP_FIELDS.supplementUnitOfMeasure.fieldPath,
          displayName: 'Unit of Measure',
          childFields: null,
        },
      ],
    },
    'qaSpecification.factPanels.drugInformation': {
      childFields: [
        {
          fieldName: TOOlTIP_FIELDS.drugFactLabelType.fieldPath,
          displayName: 'Label Type',
          childFields: null,
        },
      ],
    },
    'qaSpecification.factPanels.petNutritionalInformation': {
      childFields: [
        {
          fieldName: TOOlTIP_FIELDS.petNutritionLabelType.fieldPath,
          displayName: 'Label Type',
          childFields: null,
        },
      ],
    },
  },
  'qaSpecification.formula': {
    'qaSpecification.formula.formula': {
      childFields: [
        {
          fieldName: TOOlTIP_FIELDS.formulaDocuments.fieldPath,
          displayName: 'Document',
          childFields: null,
        },
      ],
    },
  },
};
